import React from "react";
import { useTranslation } from "react-i18next";

import SectionHeader from "../SectionHeader";
import TextLink from "../../../TextLink";
import { pillars, values } from "../data/identity";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm.identity";

export default function IdentitySection() {
  const { t } = useTranslation();

  return (
    <section className={style.identity} id="identidade-institucional">
      <SectionHeader
        label={t(`${keyI18n}.label`)}
        title={t(`${keyI18n}.title`)}
      />

      <div className={style.pillars}>
        {pillars.map(({ slug, icon, wide }) => (
          <article
            className={[style.card, wide ? style.cardWide : ""]
              .filter(Boolean)
              .join(" ")}
            key={slug}
          >
            <div className={style.pillarHead}>
              <span className={style.pillarIcon}>
                <span aria-hidden="true" className="material-symbols-sharp">
                  {icon}
                </span>
              </span>
              <h3
                className={`pgm-title-large pgm-title-large--emphasized ${style.pillarTitle}`}
              >
                {t(`${keyI18n}.pillars.${slug}.title`)}
              </h3>
            </div>
            <p className={`pgm-body-large ${style.text}`}>
              {t(`${keyI18n}.pillars.${slug}.description`)}
            </p>
          </article>
        ))}
      </div>

      <div className={style.valuesBlock}>
        <div className={style.valuesHeader}>
          <span aria-hidden="true" className={`material-symbols-sharp ${style.valuesIcon}`}>
            volunteer_activism
          </span>
          <h3 className={`pgm-label-large ${style.valuesLabel}`}>
            {t(`${keyI18n}.valuesLabel`)}
          </h3>
        </div>

        <div className={style.values}>
          {values.map(({ slug, icon }) => (
            <article className={style.valueCard} key={slug}>
              <div className={style.valueHead}>
                <span aria-hidden="true" className={`material-symbols-sharp ${style.valueIcon}`}>
                  {icon}
                </span>
                <h4 className={`pgm-title-medium ${style.valueTitle}`}>
                  {t(`${keyI18n}.values.${slug}.title`)}
                </h4>
              </div>
              <p className={`pgm-body-large ${style.text}`}>
                {t(`${keyI18n}.values.${slug}.description`)}
              </p>
            </article>
          ))}
        </div>
      </div>

      <div className={style.actions}>
        <TextLink className={`pgm-title-medium ${style.action}`} link="/quem_e_quem">
          {t(`${keyI18n}.actions.whoswho`)}
          <span aria-hidden="true" className={`material-symbols-sharp ${style.actionIcon}`}>
            arrow_forward
          </span>
        </TextLink>
        <TextLink className={`pgm-title-medium ${style.action}`} link="/noticias">
          {t(`${keyI18n}.actions.news`)}
          <span aria-hidden="true" className={`material-symbols-sharp ${style.actionIcon}`}>
            arrow_forward
          </span>
        </TextLink>
      </div>
    </section>
  );
}
